module.exports = __webpack_public_path__ + "static/media/ql-icon-games.95ee7900.svg";